import {Accordion, AccordionItem as Item} from "@szhsin/react-accordion";
import accordion_plus from "../../assets/icons/accordion_plus.svg";
import accordion_minus from "../../assets/icons/accordion_minus.svg";
import {
    QaContainer,
    HeaderCentered,
    QaInner
} from "./qa.styles";
import styles from "./styles.scss";
import React, {useState} from 'react';

const AccordionItem = ({header, expanded, onClick, ...rest}) => (
    <Item
        {...rest}
        expanded={expanded}
        header={
            <div onClick={onClick}> {/* Attach the onClick to the header only */}
                {header}
                <img
                    className={styles.chevron}
                    src={expanded ? accordion_minus : accordion_plus}
                    alt="Chevron"
                />
            </div>
        }
        className={styles.item}
        contentProps={{className: styles.itemContent}}
        panelProps={{className: styles.itemPanel}}
    />
);

export default function Qa({props}) {
    const {oftenAsked} = props; // Destructure to directly access translations

    const [expandedItem, setExpandedItem] = useState(null);

    const handleAccordionToggle = (item) => {
        setExpandedItem(expandedItem === item ? null : item);
    };

    return (
        <QaContainer className="qa-content">
            <QaInner className="qa-inner">
                <HeaderCentered>
                    <h2>{oftenAsked}</h2>
                </HeaderCentered>

                <div className={styles.accordion}>
                    <Accordion transition transitionTimeout={250}>
                        <AccordionItem
                            header={props.newRack}
                            expanded={expandedItem === props.newRack}
                            onClick={() => handleAccordionToggle(props.newRack)}
                        >
                            {props.newRackDescription}
                        </AccordionItem>

                        <AccordionItem
                            header={props.signsOfBroken}
                            expanded={expandedItem === props.signsOfBroken}
                            onClick={() => handleAccordionToggle(props.signsOfBroken)}
                        >
                            {props.signsOfBrokenDescription}
                        </AccordionItem>

                        <AccordionItem
                            header={props.qaQuestion1}
                            expanded={expandedItem === props.qaQuestion1}
                            onClick={() => handleAccordionToggle(props.qaQuestion1)}
                        >
                            {props.qaQuestion1Description}
                        </AccordionItem>

                        <AccordionItem
                            header={props.qaQuestion2}
                            expanded={expandedItem === props.qaQuestion2}
                            onClick={() => handleAccordionToggle(props.qaQuestion2)}
                        >
                            {props.qaQuestion2Description}
                        </AccordionItem>

                        <AccordionItem
                            header={props.qaQuestion3}
                            expanded={expandedItem === props.qaQuestion3}
                            onClick={() => handleAccordionToggle(props.qaQuestion3)}
                        >
                            {props.qaQuestion3Description}
                        </AccordionItem>

                        <AccordionItem
                            header={props.qaQuestion4}
                            expanded={expandedItem === props.qaQuestion4}
                            onClick={() => handleAccordionToggle(props.qaQuestion4)}
                        >
                            {props.qaQuestion4Description}
                        </AccordionItem>

                        <AccordionItem
                            header={props.qaQuestion5}
                            expanded={expandedItem === props.qaQuestion5}
                            onClick={() => handleAccordionToggle(props.qaQuestion5)}
                        >
                            {props.qaQuestion5Description}
                        </AccordionItem>

                        {/*<AccordionItem
                            header={props.qaQuestion6}
                            expanded={expandedItem === props.qaQuestion6}
                            onClick={() => handleAccordionToggle(props.qaQuestion6)}
                        >
                            {props.qaQuestion6Description}
                        </AccordionItem>*/}

                       {/*<AccordionItem
                            header={props.qaQuestion7}
                            expanded={expandedItem === props.qaQuestion7}
                            onClick={() => handleAccordionToggle(props.qaQuestion7)}
                        >
                            {props.qaQuestion7Description}
                        </AccordionItem>*/}

                        {/*ЛИШНЕЕ УДАЛИШЬ!*/}
                       {/* <AccordionItem
                            header={props.qaQuestion8}
                            expanded={expandedItem === props.qaQuestion8}
                            onClick={() => handleAccordionToggle(props.qaQuestion8)}
                        >
                            {props.qaQuestion8Description}
                        </AccordionItem>*/}
                        {/*ЛИШНЕЕ УДАЛИШЬ!*/}

                    </Accordion>
                </div>
            </QaInner>
        </QaContainer>
    );
}

